import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ParentsPortalGuard implements CanActivate {
    constructor(private route: Router) {

    }

    canActivate(): boolean {
        if (sessionStorage.getItem("token")==null || sessionStorage.getItem("LoggedIn") != "true" || sessionStorage.getItem("GUID")!="6291D72A-1B6E-4525-8057-92FEE3954A4A") {
            this.route.navigate(['/', 'parents-portal']);
            sessionStorage.clear();
            return false;
        }
        else {
            return true;
        }
    }
}